import React from 'react';


const Navbar = () => {

	// Breakpoints here are MAX-width (see tailwind.config.js), so `md:` means
	// 767px and below. The tagline is dropped on phones, where it and the logo
	// were competing for the same row.
	return (
		<nav className='px-10 py-4 md:px-5 md:py-3 box-border flex items-center justify-between gap-4 w-full'>
			<img className='max-w-[150px] md:max-w-[120px]' src='/images/phenobee_logo.svg' alt="Phenobee by Polybee" />
			<div className='font-MuseoSans text-lg lg:text-base md:hidden text-white'>Data driven decision making</div>
		</nav>
	)
}


export default Navbar;